import React, { Component } from 'react';
import Publicnav from "./publicNav.js"
import "./contact.css"
import Publicleft from "./publicleft.js"
import Publicright from "./publicright"
class Contact extends Component {

    
    constructor(props){
        super(props)  
        this.state ={
            pamaschange : "",
            public : [],
            notification:[],
            noerorrpage :  true,
            image :"https://cf-images.eu-west-1.prod.boltdns.net/v1/static/624246174001/71783484-3712-4c9a-93ea-ca05f4221b31/440d85db-2e69-430d-9776-9c92494250ba/1280x720/match/image.jpg"
        }
    }

   componentDidMount(){
     this.props.noerorrpage(this.state.noerorrpage)
     const { match: { params } } = this.props;
     console.log("params.userId",params.id)
     this.setState({
         pamaschange : params.id
     })

            this.setState({
                noticepop : false,
                loadingnews :true
            })
            // console.log("public users id", this.state.pamaschange)
            // console.log("get payment",  Auth.getProfile().userId)
            const requestOptions = {
                method: 'GET', 
                headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*'  },
            };
            console.log("public users param", params.id)
            fetch("https://uvunebeta.herokuapp.com/users/"+params.id, requestOptions)
            .then(res => res.json())
            .then((result)=>{
                if(result){
                    console.log("public users", result)
                    this.setState({
                        loadingnews :false,
                        public : result
                    })
                }else{
                    this.setState({
                        lloadingnews  :true
                    }) 
                }
            })

            fetch("https://uvunebeta.herokuapp.com/notifications?created_by="+ params.id, requestOptions)
            .then(res => res.json())
            .then((result)=>{
              if(result){
                  console.log("result notification", result.data)
                  this.setState({
                      loadingedit:true,
                      noticeshow : true,
                      notification:result.data
                  })
                 //  this.getData(result)
                 
              }
            }).catch( (error) => {
              //  console.log("errro", error);
               console.log("error load", error )
          });
        } 


        closenav = (data)=>{
            console.log("data ---===---> ", data)
            this.props.closenav(data)
         }


  render() {
    // var divStyle = {
    //     color: 'white',
    //     background: "red",
    //     height:"auto",
    //     WebkitTransition: 'all', // note the capital 'W' here
    //     "margin-top":"110px"
        
    //   };
    return (
        <div className="public-body-container"> 
            <div class="header-me"  >
       
                  <h2>Guangdong</h2>
                 {/* <div style={{backgroundImage: "url(" + this.state.image + ")", "width": "81%",margin:"auto",height:"200px"}} ></div> */}
                 {/* <img src={this.state.image}  /> */}
              </div>
 
              <Publicnav closenav={this.closenav} />
              <div className="public-body-sidevan">
                <ul className="public-body-sidevan-list">
                    <li>
                    <i class="fas fa-comment-alt" style={{fontSize:"210%"}}></i>
                    <br/>
                    <p style={{fontSize:"70%"}}>Chat now</p>
                    </li>
                    <li>
                    <i class="fas fa-envelope" style={{fontSize:"210%"}}></i>
                    <br/>
                    <p style={{fontSize:"70%"}}>Leave Messages</p>
                    </li>
                </ul>
             </div>
            

             <div className="contect-body-page">
                 <div className="contect-body-page-info">
                     <div className="contect-body-page-info-head">
                                 <p>Company Contact Information</p>
                    </div>
                    <div className="contect-body-info-image-info">
                        <div class="columns">
                            <div class="column is-two-fifths">
                            <div className="contect-body-image">
                                <img src="https://www.seoclerk.com/pics/551103-1TOqFD1502285018.jpg"  />
                                <h3>
                                   Ms. Zhang Kalinda
                                </h3>
                                <i class="fas fa-comment-alt" style={{fontSize:"170%"}}></i>
                                <p style={{position:"relative",bottom:"10px"}}>chat now</p>
                            </div>
                            </div>
                            <div class="column">
                                <div className="contect-body-info">
                                 <p><b> Telephone : </b> +123905587467</p>  
                                 <p><b> Address : </b> 	nancheng</p>  
                                 <p><b> Zip: </b> 	889955</p>  
                                 <p><b> Country/Region : </b> +123905587467</p>  	
                                </div> 
                            </div>
                            {/* <div class="column">Auto</div> */}
                        </div>
                    </div>
                    <div className="contect-body-info-message">
                       <p>Send message to supplier</p>
                      
                       <div className="contect-body-info-message-sub">
                       <b style={{textAlign:"left !important",float:"left"}}>To : Zhang Kalinda</b>
                       <br/>
                       <article class="media ontect-body-info-message-media">
                           <figure class="media-left">
                                <p class="image is-64x64">
                                Message:
                                </p>
                            </figure>
                            <div class="media-content">
                                <div class="field">
                                <p class="control">
                                    <textarea class="textarea" placeholder="Enter your inquiry details such as product name, color, size, quantity, material, etc."></textarea>
                                </p>
                                </div>
                                
                                <div class="level-left">
                                    <div class="level-item">
                                    <a class="button is-info">Submit</a>
                                    </div>
                                </div>
                                
                             
                            </div>
                            </article>
                       </div>
                    </div>
                    
                    <div className="publie-content-fooler-body">
                    <div class="content has-text-centered">
                                    <p>
                                    <strong>Bulma</strong> by <a href="https://jgthms.com">Jeremy Thomas</a>. The source code is licensed
                                    <a href="http://opensource.org/licenses/mit-license.php">MIT</a>. The website content
                                    is licensed <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">CC BY NC SA 4.0</a>.
                                    </p>
                         </div>

                    </div>
                 </div>
                 

             </div>   
                   

            

                 {/* <Publicleft name={this.state.public.display_name} image={this.state.public.image_url} address={this.state.public.address} />   */}
                
                   
                

            </div>     

    )
    

}





}

export default Contact;


// WEBPACK FOOTER //
// ./src/component/public/contact.js